import { render, staticRenderFns } from "./ArtistCreate.vue?vue&type=template&id=7df050da&scoped=true&"
import script from "./ArtistCreate.vue?vue&type=script&lang=js&"
export * from "./ArtistCreate.vue?vue&type=script&lang=js&"
import style0 from "./ArtistCreate.vue?vue&type=style&index=0&id=7df050da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df050da",
  null
  
)

export default component.exports